import { useMutation } from "@tanstack/react-query";
import { frappeMethod } from "@/lib/erp/utils";

export interface DeleteSafetyResult {
  can_delete: boolean;
  has_disabled_field: boolean;
  linked_count: number;
  linked_doctypes: Array<{ doctype: string; count: number; label: string }>;
  linked_summary: string;
  variant_count: number;
}

/**
 * On-demand safety check — call when user clicks Delete (not prefetched).
 * Returns whether the document can be permanently deleted or must be archived.
 */
export function useDeleteSafetyCheck() {
  return useMutation<
    DeleteSafetyResult,
    Error,
    { doctype: string; name: string }
  >({
    mutationFn: ({ doctype, name }) =>
      frappeMethod<DeleteSafetyResult>(
        "zaviago_backend.api.archive.check_delete_safety",
        { doctype, name },
      ),
  });
}
